module.exports = __webpack_public_path__ + "img/wenshang2.2e1e9fa1.png";